import React from 'react';
import { 	createValidationHelper, 
			validateRequired, 
			validateEmpty }
			from './lib/validation-helpers.js';
import SelectControl from './select-control.js';


export default class HonorCardSelectForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			fields: {
				product_cats: {
					value: '',
					errorMessage: '',
					fieldControl: SelectControl,
					fieldTitle: 'Gift Category',
					fieldPlaceholder: 'Select a gift category',
					fieldOptions: this.props.productCategories,	
				},
				products: {
					value: '',
					errorMessage: '',
					fieldControl: SelectControl,
					fieldTitle: 'Gift',
					fieldPlaceholder: 'Select a gift',
					fieldOptions: [{'valueKey': '', 'valueText': 'Select a gift'}],
					disabled: true
				},
			},
			formValid: false,
			selectedProduct: {}
		};

		const validationConfig = {
			product_cats: {
				validators: [validateRequired],
			},
			products: {
				validators: [validateRequired],
			},
		};

		this.formName = 'ehonorcardproductselect';
		// Register and Bind FormMethods from form wrapper
		this.bindLocalMethods = props.bindLocalMethods.bind(this);
		this.bindLocalMethods();

		this.handleProductCategorySelectChange = this.handleProductCategorySelectChange.bind(this);
		this.handleNextStep = this.handleNextStep.bind(this);

		this.validationHelper = createValidationHelper(validationConfig);
	}

	handleProductCategorySelectChange(e) {
		const catValue = e.target.value;
		let newProductList = [];

		jQuery.ajax({
			url: window.wvus_ehonor_card_ajax_vars.wvus_ehonor_card_ajax_url,
			type: 'post',
			data: {
				action: 'wvus_ehonor_card_product_category_select',
				security: window.wvus_ehonor_card_ajax_vars.wvus_ehonor_card_ajax_nonce,				
				'wvus-ehonor-card-product-cat': catValue,
			},
			success: function(data){
				newProductList = data.data.products;
				newProductList.unshift({'valueKey': '', 'valueText': 'Select a gift'});

				Object.keys(newProductList).forEach(function (key) {
					//console.log(allProductCategories[key]['valueText']);
					newProductList[key]['valueText'] = newProductList[key]['valueText'].replace('&amp;', '&').replace('&#038;', '&');
				});

				this.setState((prevState) => {
					prevState.fields.products.fieldOptions = newProductList;
					prevState.fields.products.disabled = false;
					return prevState;
				});
			}.bind(this),
			error: function(errorThrown) {
			}
		});

		this.handleValueChange(e);
	}

	componentDidMount() {
	
	}

	showSuccessState(fieldState) {
		return fieldState.isValid;
	}
	
	showErrorState(fieldState) {
		return !fieldState.isValid && fieldState.secondInteraction;
	}

	handleNextStep(e) {
		const selectedKey = this.state.fields.products.value;
		const selectedProduct = this.state.fields.products.fieldOptions.filter((field) => field.valueKey == selectedKey);
		
		this.props.handleNextStep(e, selectedProduct);
	}

	render() {
		const fields = Object.keys(this.state.fields).map((fieldName) => {
							const fieldState = this.state.fields[fieldName];
							const FieldControl = fieldState.fieldControl;
							const valueChangeHandler = (fieldName == 'products') ? this.handleValueChange :  this.handleProductCategorySelectChange;
							return (<FieldControl
										key={fieldName}
										fieldClasses={fieldName}
										fieldId={fieldName}
										fieldName={fieldName}
										fieldTitle={fieldState.fieldTitle}
										fieldState={fieldState}
										fieldOptions={fieldState.fieldOptions}
										handleBlur={this.handleBlur}
										handleValueChange={valueChangeHandler} 
										fieldType={fieldState.fieldType}
										fieldPlaceholder={fieldState.fieldPlaceholder}
										showUISuccess={this.showUISuccess(fieldState)}
										showUIError={this.showUIError(fieldState)}
										disabled={fieldState.disabled}
										>
									</FieldControl>);
						});

		return (
			<div className="ehonor-card-select-form" data-ehonor-card-select-form>
				<div className="ehonor-card-fields" >

					{ 
						fields
					}

				</div>
				<button 
					type="button" 
					className="btn btn-large btn-primary btn-full-width"
					disabled={!this.state.formValid}
					onClick={this.handleNextStep}
					data-continue-from-ehonor-card-email>
					Continue
				</button>
			</div>
		);
	}


}